// Sets a static height for layer1 of the modal on mobile to prevent CLS score increases
export const modalMobileHeight = (): string => {
  const { innerWidth } = window
  const pixelsBase = 250
  const pixelsMax = 767
  const pixelsMultiplier = 0.25
  const pixelsIncrease = Math.round((pixelsMax - innerWidth) * pixelsMultiplier)
  return `${pixelsIncrease + pixelsBase}px`
}
